import React, { FunctionComponent } from "react";
import styles from "../css/Section2.module.css";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { useSelector } from "react-redux";
import { MadeWithLove } from "../../svg_groups/made_with_love";
import { MadeWithLove_RO } from "../../svg_groups/made_with_love_ro";
import { Quotes } from "../../svg_groups/quotes";

const Section2 = () => {
  const language = useSelector((state: any) => state.language.value);

  return (
    <div
      className={styles.mainContainer}
      style={{ backgroundColor: "#F9F6E9" }}
    >
      <div className={styles.child}>
        <div className={styles.bookPhoto}>
          <div className={styles.image} />
        </div>
        <div className={styles.text}>
          <div className={styles.header}>
            <div className={styles.lifeChangingBook}>
              <span className={styles.bookDescription}>
                {" "}
                {language === "EN" && "The book which"}
                {language === "RO" && "Cartea ce"}
                {language === "RU" && "Книга которая"}{" "}
              </span>
              <span className={styles.change}>
                {" "}
                {language === "EN" && "will inspire you"}
                {language === "RO" && "te inspiră"}
                {language === "RU" && "изменит"}
              </span>
              <span className={styles.bookDescription1}> </span>
              <span className={styles.yourViewOn}>
                {" "}
                {language === "EN" && "to see the world"}
                {language === "RO" && "să vezi lumea"}
                {language === "RU" && ""}
              </span>
              <span className={styles.life}>
                {" "}
                {language === "EN" && "differently"}
                {language === "RO" && "altfel"}
                {language === "RU" && "N/a"}
              </span>
            </div>
            <div className={styles.rotatingText2PParentParent}>
              <g className={styles.arrow}>
                <svg
                  width="50"
                  height="50"
                  viewBox="0 0 50 50"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <FavoriteIcon
                    width="50"
                    height="50"
                    style={{ fill: "#C4B57C" }}
                  />
                </svg>
              </g>
              <div className={styles.rotatingText2PParent}>
                {language === "EN" && <MadeWithLove />}
                {language === "RO" && <MadeWithLove_RO />}
              </div>
            </div>

            <span className={styles.lifeChangingBook2}>
              {language === "EN" &&
                "The book that inspires you to see the world differently"}
              {language === "RO" && "Cartea ce te inspiră să vezi lumea altfel"}
              {language === "RU" &&
                "Книга, которая изменит ваш взгляд на жизнь..."}
            </span>
          </div>
          <div className={styles.frame}>
            <span className={styles.personalStory}>
              {language === "EN" && (
                <>
                  To discover your true power,{" "}
                  <strong>let go of the fear of change.</strong> Understand that
                  every change holds an opportunity to become more authentic and
                  closer to a state of fulfillment. Everything you need to be
                  happy is already within you.
                </>
              )}
              {language === "RO" && (
                <>
                  Pentru a-ți descoperi adevărata putere,{" "}
                  <strong>renunță la frica de schimbare.</strong> Ea este esența
                  evoluției tale. Înțelege că în fiecare schimbare se află o
                  oportunitate de a deveni mai autentic, mai aproape de starea
                  de împlinire. Tot ce ai nevoie pentru a fi fericit se află
                  deja în tine. <br />
                </>
              )}
              {language === "RU" &&
                "Эта книга — это не просто теория, это моя личная история и мой путь к гармонии. В ней я делюсь не только практическими психологическими техниками, но и тем, как можно превратить трудности в ступени для личного роста."}
            </span>
            <span className={styles.motivationStrengthInspiration}>
              {language === "RO" && (
                <>
                  Eu am găsit libertatea în a fi eu însămi. Și îți promit că și
                  tu o vei găsi, în felul tău. Tot ce trebuie să faci este să
                  îți asculți inima și să ai încredere în drumul tău. Așadar,
                  ridică-te, drag cititor, și îndrăznește să fii liber!”
                </>
              )}
              {language === "EN" && (
                <>
                  <strong>I found freedom in being true to myself.</strong> And
                  I promise you, you will find it too, in your own way. All you
                  have to do is listen to your heart and trust your journey.
                  <br />
                  <br />
                  So rise up, dear reader, and dare to be free!
                </>
              )}
            </span>
            <span className={styles.marianaMelnyk}>
              {language === "RO" && "Mariana Melnic"}
              {language === "EN" && "Mariana Melnic"}
            </span>
          </div>
          <span className={styles.quotationMark}>
            <Quotes />
          </span>
        </div>
      </div>
    </div>
  );
};

export default Section2;
